// Most-signal izmedju mini messengera / New Message modala i header badge-a:
// kad se konverzacija oznaci procitanom (ili poruka posalje), header treba da
// osvezi broj neprocitanih bez rucnog refresha. Komponente su odvojene, pa se
// koristi window CustomEvent umesto deljenog stanja.
const SMS_UNREAD_CHANGED = 'sms-unread-changed'

export const emitSmsUnreadChanged = () => {
  window.dispatchEvent(new CustomEvent(SMS_UNREAD_CHANGED))
}

export const onSmsUnreadChanged = (handler) => {
  window.addEventListener(SMS_UNREAD_CHANGED, handler)
  return () => window.removeEventListener(SMS_UNREAD_CHANGED, handler)
}
